var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid full-width-page-wrapper"},[_c('h3',{staticClass:"font-weight-bold page-title mb-4"},[_vm._v("All Conferences")]),_c('ifac-conference-public-list',{attrs:{"fetch-conferences":_vm.fetchConferences,"is-authenticated":_vm.isAuthenticated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }